import React, { ComponentProps, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  getPublicOrganizationApplicationTemplate,
  PublicOrganizationApplicationTemplate,
} from '~/javascripts/admin/actions/organization-applications';
import MerchantApplicationForm from '../MerchantApplicationForm';

const MerchantApplicationFormApply = () => {
  const { id } = useParams<{ id: string }>();

  const [template, setTemplate] = useState<PublicOrganizationApplicationTemplate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getPublicOrganizationApplicationTemplate(id)
      .then((res) => {
        setTemplate(res);
      })
      .catch(async (e) => {
        const body = await e;
        setError(body?.message ?? 'テンプレートの取得に失敗しました');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <h5>Loading...</h5>;
  }

  if (error || !template) {
    return <h5>{error ?? 'テンプレートが見つかりませんでした'}</h5>;
  }

  const applicationData: ComponentProps<typeof MerchantApplicationForm>['data'] = {
    templateId: template.id,
    title: template.title,
    applicationTermUrl: template.application_term_url ?? '',
    redirectUrl: template.redirect_url ?? null,
    privateMoneys: template.private_moneys,
    privateMoneyIds: template.private_money_ids,
    capitalFieldOption: template.capital_field_option,
    numberOfEmployeesFieldOption: template.number_of_employees_field_option,
    referralSourceFieldOption: template.referral_source_field_option,
    description: template.description,
    userTagGroupOptions: template.user_tag_group_options,
  };

  return <MerchantApplicationForm mode="form" data={applicationData} />;
};

export default MerchantApplicationFormApply;
